import { ShopAndSmileAPIAdapter } from '@bofrak-backend/shared';
import { BASE_URL } from '../constants/environment';
const accessToken = '';
export const apiAdapter = new ShopAndSmileAPIAdapter({
  apiEndpoint: BASE_URL,
  accessToken,
  retryCount: 0,
});
